import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { DEFAULT_THEME, THEMES, getSavedTheme } from './themes';

// Site-wide premium theme. One provider at the app root so every page shares the backdrop.
const ThemeContext = createContext({ theme: DEFAULT_THEME, setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
    const [theme, setThemeState] = useState(getSavedTheme);

    const setTheme = useCallback((next) => {
        const resolved = typeof next === 'string' ? THEMES.find((t) => t.name === next) : next;
        if (!resolved) return;
        setThemeState(resolved);
        if (resolved.name === 'null') localStorage.removeItem('theme');
        else localStorage.setItem('theme', resolved.name);
    }, []);

    // Another tab changed the theme: follow it.
    useEffect(() => {
        const onStorage = (event) => {
            if (event.key === 'theme') setThemeState(getSavedTheme());
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);
    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);

export const themeGradient = (theme) => `linear-gradient(135deg, ${theme.colors.join(', ')})`;
